const DEFAULT_FULL_LOAD_CREDITS_NON_INSTR = '36';
const DEFAULT_FULL_LOAD_CREDITS_4_YEAR = '24';
const DEFAULT_NONINSTRUCTIONAL_CC_9_MONTH = '27';
const JOB_TYPE_INSTRUCTIONAL = 'INSTRUCTIONAL';
const JOB_TYPE_9_MONTH_SUFFIX = '09';

const ROLE_VIEWER = 'V';
const ROLE_SUBMITTER = 'S';
const ROLE_REVIEWER = 'R';
const ROLE_ADMIN = 'A';
// const RECORD_PHASE_AVAILABLE = 'A';
const RECORD_PHASE_FINAL = 'F';
const RECORD_PHASE_REVIEW = 'R';
const RECORD_PHASE_VIEW = 'V';
const RECORD_PHASE_PREVIEW = 'P';
const RECORD_STATUS_FOR_REVIEW = 'R';
const RECORD_STATUS_FINAL = 'F';

const YEAR_OPTIONS = [{
  value: '2024',
  label: '2023 - 2024'
}, {
  value: '2023',
  label: '2022 - 2023'
}, {
  value: '2022',
  label: '2021 - 2022'
}, {
  value: '2021',
  label: '2020 - 2021'
}];

const WAT_JOB_TYPES = [{
  value: 'INSTRUCTIONAL',
  label: 'Instructional',
  definition: 'A faculty member whose primary duties are instructional.  They may perform a variety of teaching, research and service duties in support of the university’s mission.'
}, {
  value: 'RESEARCHER',
  label: 'Researcher',
  definition: 'A faculty member whose primary duties are research.  They may perform a variety of research and service duties in support of the university’s mission.'
}, {
  value: 'LIBRARIAN',
  label: 'Librarian',
  definition: 'Includes reference librarians, technical services librarians.'
}, {
  value: 'SPECIALIST',
  label: 'Specialist',
  definition: 'A broad category for non-instructional faculty that includes counseling and other professional non-research specialized work that is auxiliary to instruction or research programs.'
}, {
  value: 'EXTENSION AGENT',
  label: 'Extension Agent',
  definition: 'Include junior extension agents, assistant extension agents, associate extension agents, and county extension agents.'
}, {
  value: 'OTHER UHCC NON INSTRUCTIONAL FACULTY',
  label: 'Other UHCC Non Instructional Faculty',
  definition: 'Other Non-Instructional faculty at UHCC that do not fit into any of the other categories.'
}, {
  value: 'UHCC - COUNSELOR/COORDINATOR',
  label: 'UHCC - Counselor/Coordinator',
  definition: 'Non-Instructional faculty at UHCC that have split duties in Counseling and Program Coordination.'
}, {
  value: 'COUNSELOR/ADVISOR',
  label: 'Counselor/Advisor',
  definition: 'Non-Instructional faculty with primary duties in Counseling and/or Advising of students.'
}, {
  value: 'COORDINATOR (NON-INSTRUCTIONAL)',
  label: 'Coordinator (Non-Instructional)',
  definition: 'Non-Instructional faculty with primary duties in coordinating of a program.'
}, {
  value: 'OTHER NON-INSTRUCTIONAL POSITION',
  label: 'Other Non-Instructional Position',
  definition: 'Other Non-Instructional faculty (all except UHCC) that do not fit into any of the other categories.'
}];

const CAMPUS_4_YEARS = ['MAN', 'HIL', 'WOA'];

/**
 * Determines if the record can be edited.  Uses the record status, role, and record phase which is all on the record
 * object itself.
 */
function canEditRecord(recordObj) {
  const phase = recordObj.RECORD_PHASE || '';
  const status = recordObj.RECORD_STATUS || '';
  const roleOnRecord = recordObj.ROLE || '';

  // if in final record phase, no one can edit it
  if (phase === RECORD_PHASE_FINAL) {
    return false;
  }
  else if (status === RECORD_STATUS_FINAL) {
    // if in final status, only if have A role on the record and not final phase can edit
    return roleOnRecord === ROLE_ADMIN;
  }
  else if (status === RECORD_STATUS_FOR_REVIEW && roleOnRecord !== ROLE_REVIEWER && roleOnRecord !== ROLE_ADMIN) {
    // record is read only if it's for review and not an admin or reviewer role
    return false;
  }
  else {
    return roleOnRecord === ROLE_SUBMITTER || roleOnRecord === ROLE_REVIEWER || roleOnRecord === ROLE_ADMIN;
  }
}

/**
 * Common utility functions that can be used throughout the WAT app
 */
export default {
  JOB_TYPE_INSTRUCTIONAL,
  WAT_JOB_TYPES,
  getExpectedWorkload: function (campus, _jobType, jobCode) {
    let creditLoad = DEFAULT_FULL_LOAD_CREDITS_NON_INSTR;
    if (CAMPUS_4_YEARS.includes(campus)) {
      creditLoad = DEFAULT_FULL_LOAD_CREDITS_4_YEAR;
    }
    else if (jobCode.endsWith(JOB_TYPE_9_MONTH_SUFFIX)) {
      // non instructional 9 month and 11 month have different default load credits
      creditLoad = DEFAULT_NONINSTRUCTIONAL_CC_9_MONTH;
    }
    return creditLoad;
  },
  canEditRecord,
  ROLE_VIEWER,
  ROLE_SUBMITTER,
  ROLE_REVIEWER,
  ROLE_ADMIN,
  RECORD_PHASE_FINAL,
  RECORD_PHASE_REVIEW,
  RECORD_PHASE_VIEW,
  RECORD_PHASE_PREVIEW,
  RECORD_RELEASE_DATE: '2024-10-14T07:00:00.000-10:00',
  YEAR_OPTIONS
};